export default __webpack_public_path__ + "static/media/whyMUN.09b15b11.png";